import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { KhenThuongAPI } from '../../services/feature-api';
import { PageShell, Icon, HanhTrinh, KetQuaHoSo, NutXemQuyDinh, NhanMotTrongHai, Hoac, MAU_THE, fmtNgay, soNgayCon, nhanTinhTrang } from './khen-thuong-shared';

// Khen thưởng (STT 20) — /khenthuong: mỗi loại khen thưởng (bảng loai_khen_thuong) = 1 thẻ.
// Số Dự kiến nhập tay ở admin; Đã đăng ký / Đã duyệt đếm sống từ bảng chi tiết (demSong=true) khi chiến dịch có bảng riêng.
// Thẻ ĐANG MỞ: kết quả hồ sơ (nổi bật, đầu thẻ) + hạn chót + Xem quy định + số liệu + hành trình 4 bước. Thẻ SẮP MỞ: thu gọn 1 dòng + mờ.

const HanDangKy = ({ ketThucDk, tinhTrang }) => {
  const con = soNgayCon(ketThucDk);
  if (!ketThucDk) return null;
  const qua = con < 0 || tinhTrang !== 'mo';
  const gap = !qua && con <= 7;
  return (
    <div className={`flex items-center justify-between rounded-xl px-3 py-2 border ${
      qua ? 'bg-gray-100 border-gray-200 text-gray-500' : gap ? 'bg-red-50 border-red-300 text-red-700' : 'bg-amber-50 border-amber-300 text-amber-800'}`}>
      <span className="flex items-center gap-1.5 text-[12px] font-semibold">
        <Icon name={qua ? 'event_busy' : 'alarm'} size={16} />Hạn chót đăng ký
      </span>
      <span className="text-right">
        <span className="block text-[15px] font-black leading-tight">{fmtNgay(ketThucDk)}</span>
        <span className="block text-[11px] font-semibold">
          {qua ? 'Đã hết hạn' : con === 0 ? 'Hôm nay là ngày cuối' : `Còn ${con} ngày`}
        </span>
      </span>
    </div>
  );
};

const SoLieu = ({ label, value, accent }) => (
  <div className="flex-1 rounded-xl bg-gray-50 border border-gray-200 px-2 py-2 text-center">
    <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide">{label}</p>
    <p className={`text-[22px] font-black leading-tight ${accent || 'text-gray-900'}`}>{(Number(value) || 0).toLocaleString('vi-VN')}</p>
  </div>
);

// Khối điều kiện trên thẻ Du lịch 2026 (anh Bình chốt 28/09/2026): 1 bắt buộc đăng ký + cam kết, rồi ĐẠT 1 TRONG 2 YÊU CẦU
// (doanh số | tuyển sỉ). dk = BE dieuKienCuaToi — tính sống cho cả người chưa đăng ký.
const Nhan = ({ dat, chu }) => (
  <span className={`flex-shrink-0 rounded-full px-2 py-0.5 text-[11px] font-bold ${dat ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-800'}`}>{chu}</span>
);
const DieuKienDuLich = ({ dk, daNop }) => {
  if (!dk) return null;
  const nguong = (dk.nguongF1 ?? 1.5).toLocaleString('vi-VN');
  return (
    <div className="rounded-xl border border-gray-300 overflow-hidden">
      <p className="bg-gray-800 text-white text-[11px] font-black uppercase tracking-wide px-3 py-1.5">Điều kiện đi du lịch</p>
      <div className="px-3 py-2 flex items-center gap-2 border-b border-gray-200">
        <span className="w-6 h-6 rounded-full bg-gray-700 text-white text-[12px] font-black flex items-center justify-center flex-shrink-0">1</span>
        <span className="flex-1 text-[13px]"><b>Đăng ký</b> + cam kết DS 2026 từ {(dk.dsToiThieu ?? 100000000) / 1e6}tr</span>
        <Nhan dat={daNop} chu={daNop ? 'Đã đăng ký' : 'Chưa đăng ký'} />
      </div>
      <div className="px-3 py-2 space-y-1.5">
        <NhanMotTrongHai />
        <div className="flex items-start gap-2">
          <span className="w-6 h-6 rounded-full bg-blue-600 text-white text-[12px] font-black flex items-center justify-center flex-shrink-0">2</span>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-bold">Yêu cầu doanh số</p>
            <p className="text-[11px] text-gray-600">DS duyệt từ {(dk.dsToiThieu ?? 100000000) / 1e6}tr {dk.datDs200 ? '✔' : '✗'} · gấp hơn {nguong} lần F1 cao nhất {dk.datF1 ? '✔' : '✗'}</p>
          </div>
          <Nhan dat={dk.duDkDoanhSo} chu={dk.duDkDoanhSo ? 'Đạt' : 'Chưa đạt'} />
        </div>
        <Hoac />
        <div className="flex items-start gap-2">
          <span className="w-6 h-6 rounded-full bg-amber-500 text-white text-[12px] font-black flex items-center justify-center flex-shrink-0">3</span>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-bold">Yêu cầu tuyển sỉ</p>
            <p className="text-[11px] text-gray-600">{dk.canDat} sỉ mới vào từ 01/10, đơn DS duyệt đầu tiên từ 6tr</p>
          </div>
          <Nhan dat={dk.datTuyenSi} chu={`${dk.soSiDat}/${dk.canDat} sỉ`} />
        </div>
      </div>
    </div>
  );
};

const TheKhenThuong = ({ item, index, onOpen, onDangKy, onTheoDoi, onXemThe }) => {
  const mo = item.tinhTrang === 'mo';
  const daNop = !!item.trangThaiCuaToi;
  const mau = MAU_THE[index % MAU_THE.length];

  if (!mo) {
    return (
      <button type="button" onClick={onOpen}
              className="w-full text-left rounded-2xl bg-white shadow-sm border border-gray-100 overflow-hidden opacity-55 active:opacity-90">
        <div className="px-4 py-2.5 text-white flex items-center gap-3" style={{ background: mau }}>
          <span className="inline-flex items-center justify-center min-w-[26px] h-6 px-1.5 rounded-full bg-white/25 text-[12px] font-black">
            {String(item.stt ?? index + 1).padStart(2, '0')}
          </span>
          <h2 className="flex-1 text-[16px] font-black leading-tight truncate">{item.ten}</h2>
          <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold bg-black/25 text-white">
            <Icon name="schedule" size={13} />{nhanTinhTrang(item.tinhTrang)}
          </span>
        </div>
      </button>
    );
  }

  return (
    <div className="rounded-2xl bg-white shadow-md border border-gray-100 overflow-hidden active:scale-[0.99] transition-transform">
      {/* div thay button: bên trong có nút Xem quy định (button lồng button không hợp lệ) */}
      <div role="button" tabIndex={0} onClick={onOpen} className="w-full text-left cursor-pointer">
        <div className="px-4 pt-3 pb-3 text-white relative" style={{ background: mau }}>
          <div className="flex items-start justify-between gap-2">
            <span className="inline-flex items-center justify-center min-w-[28px] h-7 px-2 rounded-full bg-white/25 text-[13px] font-black">
              {String(item.stt ?? index + 1).padStart(2, '0')}
            </span>
            <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold bg-white text-emerald-700">
              <Icon name="lock_open" size={13} />{nhanTinhTrang(item.tinhTrang)}
            </span>
          </div>
          <h2 className="mt-2 text-[20px] font-black leading-tight drop-shadow">{item.ten}</h2>
        </div>

        <div className="px-3 pt-3 space-y-2.5">
          {daNop && <KetQuaHoSo hoSo={item.hoSoCuaToi} batDauDuyet={item.batDauDuyet} ketThucDuyet={item.ketThucDuyet} />}
          <div className="flex gap-2 items-stretch">
            <div className="flex-1 min-w-0"><HanDangKy ketThucDk={item.ketThucDk} tinhTrang={item.tinhTrang} /></div>
            <NutXemQuyDinh fileQuyDinh={item.fileQuyDinh} kieu="khoi" />
          </div>
          <div className="flex gap-2">
            <SoLieu label="Dự kiến" value={item.duKien} />
            <SoLieu label="Đã đăng ký" value={item.daDangKy} accent="text-blue-700" />
            <SoLieu label="Đã duyệt" value={item.pheDuyet} accent="text-emerald-700" />
          </div>
          {item.coForm && <DieuKienDuLich dk={item.dieuKienCuaToi} daNop={daNop} />}
          {item.coForm && (
            <div className="rounded-xl border border-gray-200 bg-white px-2 pt-2 pb-1.5">
              <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1.5 flex items-center justify-between">
                <span>Hành trình của bạn</span>
                {daNop && item.hoSoCuaToi?.maDangKy && <span className="normal-case tracking-normal font-black text-gray-700">{item.hoSoCuaToi.maDangKy}</span>}
              </p>
              <HanhTrinh trangThai={item.trangThaiCuaToi} duDkDoanhSo={item.hoSoCuaToi?.duDk}batDauDuyet={item.batDauDuyet} ketThucDuyet={item.ketThucDuyet} />
            </div>
          )}
        </div>
      </div>

      <div className="px-3 pb-3 pt-2.5">
        {item.coForm ? (
          <div className="grid grid-cols-2 gap-2">
            <button type="button" onClick={daNop ? onXemThe : onDangKy}
                    className={`rounded-xl py-2.5 px-2 text-[13px] font-bold leading-tight text-center flex items-center justify-center gap-1 shadow-md ${
                      daNop ? 'bg-gradient-to-r from-amber-400 to-yellow-300 text-amber-950' : 'bg-red-600 text-white active:bg-red-700'}`}>
              <Icon name={daNop ? 'celebration' : 'edit_document'} size={16} />{daNop ? 'Xem lại màn hình đăng ký' : 'Đăng ký + cam kết'}
            </button>
            <button type="button" onClick={onTheoDoi}
                    className="rounded-xl py-2.5 text-[13px] font-bold flex items-center justify-center gap-1 bg-white border-2 border-red-600 text-red-700 active:bg-red-50">
              <Icon name="track_changes" size={16} />Theo dõi kết quả
            </button>
          </div>
        ) : (
          <button type="button" onClick={onOpen}
                  className="w-full rounded-xl py-2.5 text-[13px] font-bold flex items-center justify-center gap-1 bg-gray-100 text-gray-700">
            <Icon name="info" size={16} />Xem chi tiết
          </button>
        )}
      </div>
    </div>
  );
};

const KhenThuongPage = ({ accessToken, userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!accessToken) return;
    setLoading(true); setError('');
    const r = await KhenThuongAPI.getList(accessToken);
    if (r.success) setItems(Array.isArray(r.data) ? r.data : []);
    else setError(r.error || 'Không tải được danh sách khen thưởng');
    setLoading(false);
  }, [accessToken]);

  useEffect(() => { load(); }, [load]);

  const soMo = items.filter((i) => i.tinhTrang === 'mo').length;

  return (
    <PageShell userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} onRefreshPoints={onRefreshPoints} title="Khen thưởng" backTo="/dashboard">
      <div className="px-3 pt-3 space-y-3">
        <div className="rounded-2xl px-4 py-3 text-white shadow-md flex items-center justify-between gap-3"
             style={{ background: 'linear-gradient(135deg, #7F1D1D, #DC2626 60%, #F59E0B)' }}>
          <p className="text-[18px] font-black leading-tight flex items-center gap-1.5">
            <Icon name="emoji_events" size={22} className="text-amber-300" />Khen thưởng 2026
          </p>
          <div className="flex items-center gap-1.5 text-[12px] font-bold">
            <span className="rounded-full bg-white/20 px-2.5 py-1">Tổng <span className="text-[15px] font-black">{loading ? '…' : items.length}</span></span>
            <span className="rounded-full bg-white text-emerald-700 px-2.5 py-1">Đang mở <span className="text-[15px] font-black">{loading ? '…' : soMo}</span></span>
          </div>
        </div>

        {error && <div className="rounded-xl bg-red-50 border border-red-200 text-red-700 text-[13px] px-3 py-2">{error}</div>}
        {loading && !items.length && <p className="text-center text-gray-400 text-sm py-8">Đang tải...</p>}
        {!loading && !items.length && !error && <p className="text-center text-gray-400 text-sm py-8">Chưa có chương trình nào.</p>}

        {items.map((item, idx) => (
          <TheKhenThuong key={item.id} item={item} index={idx}
                         onOpen={() => navigate(`/khenthuong/${item.ma}`)}
                         onDangKy={() => navigate('/khenthuong/du-lich-2026/dang-ky')}
                         onTheoDoi={() => navigate('/khenthuong/du-lich-2026/tinh-trang')}
                         onXemThe={() => navigate('/khenthuong/du-lich-2026/chuc-mung')} />
        ))}
      </div>
    </PageShell>
  );
};

export default KhenThuongPage;
